//
// SVG Fix for IE 9-11
// In IE SVGElement has no innerHTML property
//
if (!("innerHTML" in SVGElement.prototype)) {
    Object.defineProperty(SVGElement.prototype, "innerHTML", {
        get() {
            let child;
            let i;
            let len;

            const temp = document.createElement("div");
            const node = this.cloneNode(true);
            const ref = node.childNodes;

            for (i = 0, len = ref.length; i < len; i++) {
                child = ref[i];
                temp.append(child);
            }

            return temp.innerHTML;
        },
        set(markup) {
            let element;
            let i;
            let len;

            while (this.firstChild) {
                this.firstChild.parentNode.removeChild(this.firstChild);
            }

            const adjustedMarkup = `<svg id='wrapper' xmlns='http://www.w3.org/2000/svg'>${markup}</svg>`;

            const div = document.createElement("div");
            div.innerHTML = adjustedMarkup;

            const svg = div.querySelector("svg#wrapper");
            const ref = svg.childNodes;
            const results = [];

            for (i = 0, len = ref.length; i < len; i++) {
                element = ref[i];
                results.push(this.appendChild(element));
            }

            return results;
        },
        enumerable: false,
        configurable: true,
    });
}

if (!Element.prototype.matches) {
    /* eslint-disable @typescript-eslint/unbound-method */
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    /* eslint-enable @typescript-eslint/unbound-method */
}

if (!Element.prototype.closest) {
    // eslint-disable-next-line func-names
    Element.prototype.closest = function (s) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
